import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SearchComponent } from './components/search/search.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { SubMenubarComponent } from './components/sub-menubar/sub-menubar.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    SearchComponent,
    UserMenuComponent,
    SubMenubarComponent
  ],
  template: `
    <div class="layout-header">
      <app-header-breadcrumb />
      <div class="layout-header-right">
        <app-header-search />
        <app-header-user />
      </div>
    </div>
    <app-sub-menubar />
  `,
  styleUrl: './header.component.scss'
})
export class AppHeaderComponent {}
